module.exports = __webpack_public_path__ + "img/parents-photo-enrollment-2.bb286c7b.jpg";